export enum DetailPdfPageType {
  CONTRACT = 'CONTRACT',
  PRIVATE_OFFER = 'PRIVATE_OFFER',
  RESELLER_AUTH = 'RESELLER_AUTH',
}

export enum DetailPdfSurface {
  PLATFORM = 'platform',
  CANVAS = 'canvas',
  HUBSPOT = 'hubspot',
}

export enum DetailPdfCloud {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
}

export type UseDownloadDetailPdfParams = {
  pageType: DetailPdfPageType
  partnerId: string
  entityId: string
  cloud: DetailPdfCloud
}
